import React, { FC } from 'react';

import { colors } from '@crehana/ui';
import {
  Clock2,
  Star,
  User,
  LevelEsencialVertical,
  LevelIntermediateVertical,
  LevelCompleteVertical,
} from '@crehana/icons';

import { useTranslation } from '@crehana/i18n';

import parseCourseSeconds from 'Utils/parseCourseSeconds';

const { secondaryMain, yellowMain, purpleLighter, blueLight } = colors;

interface ICourseStats {
  course: {
    score: {
      average: number;
      total: number;
    };
    level: {
      name: string;
    };
    enrollments: number;
    duration: number;
  };
}

const CourseStats: FC<ICourseStats> = ({ course }) => {
  const {
    score: { average, total },
    enrollments,
    duration,
    level: { name },
  } = course;
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap justify-between">
      <div className="flex items-center mb-16 mr-16">
        <Star size={20} color={yellowMain} className="mr-8" />
        <p className="font-subtitle3">
          {(Math.round(average * 100) / 100).toFixed(2)}{' '}
          <span className="font-body3 text-gray-dark ">({total})</span>
        </p>
      </div>
      <div className="flex items-center mb-16 mr-16">
        <User size={20} color={secondaryMain} className="mr-8" />
        <span className="font-subtitle3">
          {t('COURSE_FREE_STAT_STUDENTS', { count: enrollments })}
        </span>
      </div>
      <div className="flex items-center sm:mb-16 mr-16">
        <Clock2 size={20} color={purpleLighter} className="mr-8" />
        <span className="font-subtitle3">{parseCourseSeconds(duration)}</span>
      </div>
      <div className="flex items-center sm:mb-16">
        {
          {
            Esencial: <LevelEsencialVertical size={18} color={blueLight} />,
            Intermedio: (
              <LevelIntermediateVertical size={18} color={blueLight} />
            ),
            Avanzado: <LevelCompleteVertical size={18} color={blueLight} />,
            Completo: <LevelCompleteVertical size={18} color={blueLight} />,
          }[name]
        }
        <span className="ml-8 sm:flex font-subtitle3">
          {t('COURSE_FREE_STAT_COURSE_LEVEL', {
            interpolation: { level: name },
          })}
        </span>
      </div>
    </div>
  );
};

export default CourseStats;
